/**
 * Shown over a dashboard when the system default was changed after the user saved their own
 * layout: they can take the new one (their own is discarded) or keep theirs, which stops the notice.
 */
export default function LayoutUpdateBanner({ updatedAt, busy, error, onUseIt, onKeepMine }: {
    updatedAt: string
    busy: boolean
    error: string | null
    onUseIt: () => void
    onKeepMine: () => void
}) {
    const when = new Date(updatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
    return (
        <div className="layout-update-banner" role="status">
            <span>
                The system default for this dashboard was updated on {when}, after you saved your layout.
                {error && <strong className="layout-update-error"> {error}</strong>}
            </span>
            <button className="btn btn-secondary btn-sm" onClick={onUseIt} disabled={busy}>Use the new one</button>
            <button className="btn btn-secondary btn-sm" onClick={onKeepMine} disabled={busy}>Keep mine</button>
        </div>
    )
}
